import { apiClient } from '@/lib/api-client';
import type { Booking } from '@/types/api';

export type BookingInput = {
  startsAt: string;
  durationMin: number;
  name: string;
  phone: string | null;
  patientId: string | null;
  dentistId: string | null;
};

/** Fired on window after a booking is created, changed or cancelled (the top bar's next patient listens). */
export const BOOKINGS_CHANGED = 'dentlog:bookings-changed';
const changed = () => window.dispatchEvent(new Event(BOOKINGS_CHANGED));

export const bookingsApi = {
  async list(from: Date, to: Date, dentistId: string | null) {
    const { data } = await apiClient.get<Booking[]>('/bookings', {
      params: { from: from.toISOString(), to: to.toISOString(), dentistId: dentistId ?? undefined },
    });
    return data;
  },
  async create(input: BookingInput) {
    const { data } = await apiClient.post<Booking>('/bookings', input);
    changed();
    return data;
  },
  /** Move, extend or edit. */
  async update(id: string, patch: Partial<BookingInput>) {
    const { data } = await apiClient.patch<Booking>(`/bookings/${id}`, patch);
    changed();
    return data;
  },
  async cancel(id: string) {
    await apiClient.post(`/bookings/${id}/cancel`);
    changed();
  },
};
